// src/modules/app-views/_apps/appmulti/orders/pages/Init/components/tableColumns/statusColumn.js
// *******************************************************************************
// STATUS COLUMN
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';
import ordersService from '../../../../service';

const statusColumn = buildColumnProps => ({
  key: 'status',
  title: translateX('status'),
  dataIndex: 'status',
  ...buildColumnProps('status', { sort: true }),
  align: 'center',
  render: (_, record) => {
    const s = ordersService.getDisplayStatus(record);
    return <Tag color={ordersService.getStatusColor(s)}>{translateX(s)}</Tag>;
  },
});

export default statusColumn;
